module.exports = `
  type NewsCategory {
    news_category_id: Int
    name: String
    active: Boolean
    done: Boolean
  }
`;
